function consent(properties) {
    return {
        id: 'userConsents',
        component: 'magic-corex-sign-up-consents',
        isDataField: true,
        isStandAlone: true,
        properties: {
            'collapsible-marketing-preferences': properties.collapsibleMarketingPreferences,
        },
        converter: function (formValue) {
            var _a;
            var _b = (_a = formValue.userConsents) === null || _a === void 0 ? void 0 : _a.value, privacy = _b[0], terms = _b[1], marketing = _b[2];
            return {
                termsAndConditionsVersion: terms.version.toString(),
                privacyPolicyVersion: privacy.version.toString(),
                optIn: marketing === null || marketing === void 0 ? void 0 : marketing.consented,
            };
        },
    };
}

export { consent };
